module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), (!_vm.showLoading) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "top1"
  }, [_c('img', {
    attrs: {
      "src": _vm.article && _vm.article.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.article && _vm.article.author.loginname)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time",
    domProps: {
      "textContent": _vm._s(_vm.article && _vm.article.create_at.substring(0, 10))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top2"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.article && _vm.article.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "a_detail"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n            " + _vm._s(_vm.article && _vm.article.visit_count) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n            " + _vm._s(_vm.article && _vm.article.reply_count) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.article && _vm.article.content)
    }
  }), _vm._v(" "), (_vm.article.replies && _vm.article.replies.length) ? _c('div', {
    staticClass: "comment"
  }, [_c('ul', _vm._l((_vm.article.replies), function(comment) {
    return _c('li', [_c('v-comment-item', {
      attrs: {
        "comment": comment
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.userInfo.userId) ? _c('div', {
    staticClass: "go_comment"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.go_comment),
      expression: "go_comment"
    }],
    staticClass: "gc_content",
    attrs: {
      "placeholder": "回复支持Markdown语法,请注意标记代码"
    },
    domProps: {
      "value": (_vm.go_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.go_comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button_group"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.handleComment
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "cancle"
    },
    on: {
      "click": _vm.cancleComment
    }
  }, [_vm._v("取消")])])]) : _c('div', {
    staticClass: "unlogin"
  }, [_vm._v("\n        您还未"), _c('router-link', {
    attrs: {
      "to": "/login",
      "tag": "span"
    }
  }, [_vm._v("登录")])], 1)]) : _c('v-loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3576578a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Topic.vue
// module id = 136
// module chunks = 1